import script from "./thinkBuyGoods.vue?vue&type=script&setup=true&lang=js"
export * from "./thinkBuyGoods.vue?vue&type=script&setup=true&lang=js"

import "./thinkBuyGoods.vue?vue&type=style&index=0&id=453a772f&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-453a772f"]])

export default __exports__